import { HeaderStyled } from 'shared/components/Header/Header.styles';
import styled, { css } from 'styled-components';

export const FAQCategoryBody = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
`;

export const SubcategoriesWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const SubcategoryWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 342px;
    margin-right: 48px;
    gap: 24px;

    h3 {
      pointer-events: none;
    }

    p {
      cursor: pointer;

      &:hover {
        color: ${theme.colors.textLinkLinkSecondary2100};
      }

      &:active {
        color: ${theme.colors.textLinkLinkVisitedFunction4100};
      }

      &:focus-visible {
        color: ${theme.colors.textLinkLinkSecondary2100};
        box-shadow: unset;
        outline: 3px solid ${theme.colors.chartChartLightbluePressedSecondary240};
        border-radius: 4px;
      }
    }
  `}
`;

export const SubcategoryIconWrapper = styled.div`
  ${({ theme }) => `
        border-radius: 50%;
        display: flex;
        width: 34px;
        height: 34px;
        background: ${theme.colors.backgroundSecondaryGrey05};
        box-shadow: ${theme.elevations.extraSunken};
        
        svg {
            margin: auto;
            height: 16px;
            width: 16px;
        }
    `}
`;

export const FAQCategoryWrapper = styled.div`
  ${({ theme }) => `
    h1 {
      font-weight: 700;
      margin-bottom: 12px;
    }
    height: 100%;

    @media screen and (max-width: ${theme.breakpoints.medium}) {
      ${HeaderStyled} {
        margin-bottom: 16px;
      }

      h1 {
        font-weight: 500;
        margin: 12px 0 0;
      }
      ${SubcategoriesWrapper} {
        flex-wrap: wrap;

        ${SubcategoryWrapper} {
          width: 305px;
          gap: 20px;
          margin-right: 26px;
          margin-bottom: 32px;
        }
      }
    }

    @media screen and (max-width: ${theme.breakpoints.small}) {
      h1 {
        margin: 2px 0 0;
      }
      ${SubcategoryWrapper} {
        min-height: unset;
      }
    }
  `}
`;
